import { useQuery } from '@tanstack/react-query';
import { championshipsApi, Championship } from '../services/api';
import { useSite } from '../contexts/SiteContext';

export const useChampionships = () => {
  const site = useSite();
  const filters = { sport: site.sport, level: site.level };
  
  return useQuery<Championship[], Error>({
    queryKey: ['championships', filters],
    queryFn: async () => {
      const response = await championshipsApi.getAll(filters);
      return response.data;
    },
  });
};

export const useChampionship = (slug: string) => {
  return useQuery<Championship, Error>({
    queryKey: ['championship', slug],
    queryFn: async () => {
      const response = await championshipsApi.getBySlug(slug);
      return response.data;
    },
    enabled: !!slug,
  });
};
